<template>
  <aceHotel :revinate_token="revinate_token" :template="template" :portal="portal" :connection_data="connection_data" @emitRegistrationMethodData="handleEmit" />
</template>
<script>
import aceHotel from '@/components/custom/aceHotel/index'
export default {
  name: 'custom_template_ace_new_york',
  props: [ 'template', 'portal', 'connection_data' ],
  components: { aceHotel },
  data(){
    return{
      revinate_token: '9d172834-32f0-4df0-8e36-96f1d771b929'
    }
  },
  methods: {
    handleEmit:function(data){
      this.$emit('emitRegistrationMethodData', data);
    }
  }
}
</script>
<style>
</style>